import angular from 'angular';

angular
  .module('cloudX')
  .factory('dashboardSvc', [
    '$q',
    '$state',
    'resourceFactorySvc',
    'flySvc',
    'dataCache',
    'checkSecurity',
    '$http',
    'appUrls',
    '$timeout',
    dashboardSvc,
  ]);

function dashboardSvc(
  $q,
  $state,
  resourceFactorySvc,
  flySvc,
  dataCache,
  checkSecurity,
  $http,
  appUrls,
  $timeout,
) {
  var topCustomerRevenue = [];
  var billedPerMonth = [];
  var topCustomerDebt = [];
  var complianceStatistics = undefined;

  function showError(error) {
    flySvc.error(error.data.code, error.data.parameters);
  }

  function safeGetTopCustomerRevenue(companyId) {
    if (!checkSecurity('InvoiceFinal:r')) return $q.when([]);
    return resourceFactorySvc
      .get('invoice')
      .topcustomerrevenue({ companyId: companyId }, function(result) {
        topCustomerRevenue = result;
      }).$promise;
  }

  function reloadTopCustomerRevenue(companyId) {
    if (!companyId) {
      return dataCache.ready().then(() => {
        companyId = dataCache.getDefaultCompany().id;
        return safeGetTopCustomerRevenue(companyId);
      });
    } else {
      return safeGetTopCustomerRevenue(companyId);
    }
  }

  function safeGetBilledPerMonth(companyId) {
    if (!checkSecurity('InvoiceFinal:r')) return $q.when([]);
    return resourceFactorySvc
      .get('invoice')
      .billedpermonth({ companyId: companyId }, function(result) {
        billedPerMonth = result;
      }).$promise;
  }

  function reloadBilledPerMonth(companyId) {
    if (!companyId) {
      return dataCache.ready().then(() => {
        companyId = dataCache.getDefaultCompany().id;
        return safeGetBilledPerMonth(companyId);
      });
    } else {
      return safeGetBilledPerMonth(companyId);
    }
  }

  function safeGetTopCustomerDebt(companyId) {
    if (!checkSecurity('InvoiceFinal:r')) return $q.when([]);
    return resourceFactorySvc.get('invoice').topcustomerdebt(
      {
        companyId: companyId,
      },
      function(result) {
        topCustomerDebt = result;
      },
    ).$promise;
  }

  function reloadTopCustomerDebt(companyId) {
    if (!companyId) {
      return dataCache.ready().then(() => {
        companyId = dataCache.getDefaultCompany().id;
        return safeGetTopCustomerDebt(companyId);
      });
    } else {
      return safeGetTopCustomerDebt(companyId);
    }
  }

  function safeComplianceStatistics(companyId) {
    const promise = $http.get(appUrls.api + '/api/compliance/statistics?companyId=' + companyId);

    promise.then(function onfullFilled(response) {
      complianceStatistics = response.data;
      //return for chaining
      return response;
    });

    return promise;
  }

  function reloadComplianceStatistics(companyId) {
    if (!companyId) {
      return dataCache.ready().then(() => {
        companyId = dataCache.getDefaultCompany().id;
        return safeComplianceStatistics(companyId);
      });
    } else {
      return safeComplianceStatistics(companyId);
    }
  }

  return {
    getTopCustomerRevenue: function() {
      return topCustomerRevenue;
    },
    reloadTopCustomerRevenue: reloadTopCustomerRevenue,

    getBilledPerMonth: function() {
      return billedPerMonth;
    },
    reloadBilledPerMonth: reloadBilledPerMonth,

    getTopCustomerDebt: function() {
      return topCustomerDebt;
    },
    reloadTopCustomerDebt: reloadTopCustomerDebt,
    getComplianceStatistics: function() {
      return complianceStatistics;
    },
    reloadComplianceStatistics: reloadComplianceStatistics,
  };
}
